<template>
	<div>
		<table :class="{ 'can-edit': canEdit }">
			<tr v-for="(item, index) in kpisSorted" :key="index" :class="{ 'kpi-complete': item.complete }" @click="onEditKpi(item)">
				<td>
					<div>
						<div>
							<div v-html="item.text"></div>
							<div class="due-date" v-if="!item.complete">Due: <AppDate :date="item.dueDateUTC" null-date="N/A" show-date/></div>
							<v-chip v-if="item.complete" class="v-chip--x-small" color="green" small text-color="white">Complete</v-chip>
						</div>

						
					</div>
				</td>
				<td v-if="canEdit" style="width:1px;">
						<div @click.stop="onDeleteKPI(item)">
							<v-tooltip bottom>
								<v-btn slot="activator" small icon ripple>
									<v-icon color="grey">delete</v-icon>
								</v-btn>
								<span>Delete KPI</span>
							</v-tooltip>
						</div>
				</td>
			</tr>
		</table>
		<template >
				
			</template>

		<v-spacer></v-spacer>

		<div v-if="canEdit" class="text-xs-right">
			<v-btn flat @click="onAddKpi"> <v-icon left>add</v-icon>Add KPI </v-btn>
		</div>
		<div v-else-if="kpis.length === 0" class="text-xs-left">		
			<v-subheader>
				No KPI's have been added yet
			</v-subheader>
		</div>
		
	</div>
</template>

<script>
	export default {
		props: {
			kpis: {
				type: Array,
				required: true
			},
			canEdit: {
				type: Boolean,
				required: false,
				default: true
			}
		},
		data() {
			return {};
		},
		computed: {
			kpisSorted() {
				return this.completeSorted.concat(this.notCompleteSorted);
			},
			notCompleteSorted() {
				return this.kpis.filter(x=> !x.complete)
								.sort(function(a, b) {

					if (a.dueDateUTC == null)
						return 1;

					return new Date(a.dueDateUTC) - new Date(b.dueDateUTC);
				});
			},
			completeSorted() {
				return this.kpis.filter(x=> x.complete);
			}
		},
		methods: {
			onEditKpi(item) {
				this.$emit('onEditKpi', item);
			},
			onAddKpi() {
				this.$emit('onAddKpi');
			},
			onDeleteKPI(item) {
				if (confirm('Are you sure you wish to delete this goal KPI?')) {
					this.$emit('onDeleteKpi', item.id);
				}
			}
		}
	};
</script>

<style scoped>
	table {
		width: 100%;
		text-align: left;
    	font-size: 13px;
		border-collapse:collapse;
	}
	table td {
		padding-top: 8px;
		padding-bottom: 8px;
		padding-left: 16px;
		padding-right: 16px;
		line-height: 24px;
	}
	.kpi-complete {
		background-color: rgba(0, 255, 0, 0.1);
	}
	table.can-edit tr:hover td {
		cursor: pointer;
		background: rgba(0,0,0,.04);
	}
	.due-date {
		color: rgba(0,0,0,.54);
	}
</style>
